












































import StationItem from './components/item.vue'
import { apiMerchantMerchantListByIds } from '@/api'
import { asRequiredDeep } from 'vtils'
import { AsyncReturnType } from 'vtils/types'
import { computed, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApiPlus, useQuery } from '@/hooks'
import { navigateBack } from '@/router'
import { stationBus } from './bus'
import { Track } from '@/utils'
import { useWaterfall, XWaterfallLoad } from '@/components'

export default defineClassComponent(
  {
    components: {
      StationItem,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '选择自提点',
        }))
      }

      query = useQuery<{
        selectedId: string
        availableIds: string[]
      }>({
        availableIds: {
          transformer: JSON.parse,
        },
      })

      loading = computed(() => this.api.loading)

      api = useApiPlus({
        latLngData: () =>
          dcb
            .getLocation()
            .catch(() => ({} as AsyncReturnType<typeof dcb.getLocation>)),
      })

      latLngData = computed(() => this.api.data.latLngData)

      selectedDivision = ref({
        city: '贵阳市',
      })
      divisionPickerVisible = ref(false)
      handleDivisionPickerConfirm = (res: any) => {
        this.selectedDivision.value = res
      }

      tempKeyword = ref('')
      keyword = ref('')
      handleSearchConfirm = () => {
        this.keyword.value = this.tempKeyword.value
      }

      waterfall = useWaterfall('list', {
        reloadWatcher: () => [
          this.selectedDivision.value,
          this.keyword.value,
        ],
      })

      // 加载数据
      handleLoadData: XWaterfallLoad = async ({ pageNumber }) => {
        return apiMerchantMerchantListByIds({
          ids: this.query.availableIds,
          pageIndex: pageNumber,
          pageSize: 10,
          cityName: this.selectedDivision.value.city,
          selfPickupName: this.keyword.value,
          longitude: (this.latLngData.value.longitude || '').toString(),
          latitude: (this.latLngData.value.latitude || '').toString(),
        }).then(asRequiredDeep)
      }

      // 点击项目
      handleItemClick = (item: any) => {
        stationBus.emit('select', item)
        navigateBack()
      }
    },
)
